export const AUTOMATE_MP4 = 'https://cdn.livechat-static.com/api/file/lc/img/default/assets/automate_01.mp4';

export const CHATS_MP4 = 'https://cdn.livechat-static.com/api/file/lc/img/default/assets/chats_01.mp4';

export const ENGAGE_MP4 = 'https://cdn.livechat-static.com/api/file/lc/img/default/assets/engage_02.mp4';
